import { render, staticRenderFns } from "./otpForm.vue?vue&type=template&id=36be8f54&scoped=true"
import script from "./otpForm.vue?vue&type=script&lang=js"
export * from "./otpForm.vue?vue&type=script&lang=js"
import style0 from "./otpForm.vue?vue&type=style&index=0&id=36be8f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be8f54",
  null
  
)

export default component.exports